// src/services/auth.service.js
import { API_CONFIG } from '../config/constants';
import FingerprintService from './fingerprint.service';

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

export const authService = {

    login: async ({ email, password }) => {
        try {
            // 1. D'abord effacer toutes les données d'authentification
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            localStorage.removeItem('username');


            // 2. Attendre un moment pour s'assurer que tout est effacé
            await new Promise(resolve => setTimeout(resolve, 100));

            // 3. Faire la requête de login
            const fingerprint = await FingerprintService.getFingerprint();
            const response = await fetch(`${API_CONFIG.BASE_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password, fingerprint })
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Échec de la connexion');
            }

            const data = await response.json();

            // 4. Stocker les nouvelles données
            if (data.token) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('userId', data.user_id);
                console.log(data);
                if (data.username) {
                    localStorage.setItem('username', data.username);
                }
            }

            return data;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    },

    register: async (userData) => {
        try {
            const fingerprint = await FingerprintService.getOrCreateFingerprint();

            const response = await fetch(`${API_CONFIG.BASE_URL}/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...userData,
                    fingerprint
                })
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('userId', data.user_id);
                if (data.username) {
                    localStorage.setItem('username', data.username);
                }
            }

            return data;
        } catch (error) {
            console.error('Registration error:', error);
            throw error;
        }
    },

    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('username');
        window.location.href = '/login';
    },

    isAuthenticated: () => {
        return !!localStorage.getItem('token');
    },

    isAuthenticatedWithName: () => {
        return !!localStorage.getItem('usrname');
    },

    getCurrentUser: async () => {
        try {
            const response = await fetch(`${API_CONFIG.BASE_URL}/user/profile`, {
                method: 'GET',
                headers: getAuthHeader(),
                credentials: 'include'
            });

            if (!response.ok) {
                if (response.status === 401) {
                    authService.logout();
                    throw new Error('Session expirée');
                }
                const error = await response.json();
                throw new Error(error.error || 'Échec de la récupération du profil');
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching user profile:', error);
            throw error;
        }
    },

    changePassword: async (passwordData) => {
        try {
            const response = await fetch(`${API_CONFIG.BASE_URL}/user/change-password`, {
                method: 'POST',
                headers: getAuthHeader(),
                credentials: 'include',
                body: JSON.stringify({
                    current_password: passwordData.currentPassword,
                    new_password: passwordData.newPassword
                })
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Échec du changement de mot de passe');
            }

            return await response.json();
        } catch (error) {
            console.error('Error changing password:', error);
            throw error;
        }
    }
};